import { Request } from 'commons/utils/request'
import { DateTime } from 'ui/components/DateTime'
import { DownloadLink } from 'ui/components/DownloadLink'
import { TableColumn } from 'ui/components/Table'
import { Toast } from 'ui/components/Toast'

import { PCTFile } from '../../../types/PCT'

export const columns = (): TableColumn<PCTFile>[] => [
  {
    title: 'File Name',
    align: 'left',
    render: ({ fileName }) => {
      const name = fileName.split('_id__')[1]

      return (
        <DownloadLink
          direct
          parametersForm={{ fileName }}
          baseUrl={Request.urls.bank.parsedTransactionsDownload}
          name={name || fileName}
          handleError={(error: string) => Toast.error('Error', error)}
        >
          {name || fileName}
        </DownloadLink>
      )
    }
  },
  {
    title: 'Parsed Date',
    align: 'left',
    render: ({ lastModifiedDate }) => <DateTime date={lastModifiedDate} />
  }
]
